<template>
  <div class="card-parent">
    <div class="card">
      <div class="card__header">
        <div v-if="icon" class="card__icon">
          <font-awesome-icon size="lg" :icon="icon"></font-awesome-icon>
        </div>
        <span class="card__title title-large" v-if="title">{{ title }}</span>
      </div>
      <div
        class="card__body"
        :class="icon && !pull ? 'card__body--has-icon' : ''"
      >
        <slot />
      </div>
      <div role="complementary" class="card__shadow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card',
  props: {
    title: {
      type: String,
    },
    icon: {
      type: [String, Array, Object],
    },
    pull: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.card-parent {
  z-index: 1;
  width: 100%;
}

.card {
  background: white;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  position: relative;
  width: 100%;

  &__shadow {
    @include large-shadow;
  }

  &__header {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;

    .card__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 40px;
      border-radius: 4px;
      margin-right: 16px;
      background: color('teal');
      color: color('teal', 'text');
    }

    .card__title {
      margin-top: 4px;
    }
  }

  &__body {
    &--has-icon {
      margin-left: 40px + 16px;
    }

    &--pull {
      margin-left: 0;
    }
  }
}
</style>
